import { Box, Typography } from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/router';

const CustomLink = ({
    disableLink = false,
    isText = false,
    useNativeLink = false,
    href,
    children,
    useLinkColor = false,
    linkStyles = {},
    useWrapper = false,
    ...props
}) => {
    const router = useRouter();

    if (useNativeLink) {
        const handleClick = (e) => {
            e.preventDefault();
            router.push(href); // navegación client-side
        };

        return (
            <a href={href} style={{ ...linkStyles }}>
                {children}
            </a>
        );
        // return (
        //     <a href={href} style={{ ...linkStyles }}>
        //         {children}
        //     </a>
        // );
    }
    if (disableLink) {
        return <Box {...props}>{children}</Box>;
    }

    if (isText) {
        return (
            <Typography component={'span'} {...props} color={useLinkColor ? 'primary.main' : 'text.primary'}>
                {children}
            </Typography>
        );
    }

    if (useWrapper) {
        return (
            <Link href={href} style={{ ...linkStyles }} prefetch={false}>
                {children}
            </Link>
        );
    }

    return (
        <Link href={href} style={{ ...linkStyles }} prefetch={false}>
            {children}
        </Link>
    );
};

export default CustomLink;
